import { motion } from "@smartsheet/design-tokens";
import { themed } from "@smartsheet/sds-theme-internal";
export var chipTheme = themed({
  borderRadius: {
    "lodestar-light": "2px",
    "ursa-light": "4px"
  },
  height: {
    medium: "28px",
    small: "24px",
    xsmall: "20px"
  },
  padding: {
    left: {
      xsmall: "0.5px",
      small: "4px",
      medium: "4px"
    },
    right: {
      xsmall: "0.5px",
      small: "6px",
      medium: "6px"
    }
  },
  showIcon: {
    "lodestar-light": false,
    "ursa-light": true
  },
  motion: {
    animation: {
      "lodestar-light": "",
      // Note: intentionally breaking away from the default transition timing since the button
      // is so small.
      "ursa-light": "background-color ".concat(motion.animation.default, ", opacity 0.1s ").concat(motion.easing.default)
    }
  }
});
//# sourceMappingURL=chipTheme.js.map